var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.319,
    height: 19.319,
    viewBox: "0 0 19.319 19.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-square",
    "data-name": "Icon feather-plus-square",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M6.647,4.5H21.673a2.147,2.147,0,0,1,2.147,2.147V21.673a2.147,2.147,0,0,1-2.147,2.147H6.647A2.147,2.147,0,0,1,4.5,21.673V6.647A2.147,2.147,0,0,1,6.647,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M18,12v8.586",
    transform: "translate(-3.84 -2.134)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M12,18h8.586",
    transform: "translate(-2.134 -3.84)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusSquare);
export default __webpack_public_path__ + "static/media/icon-plus-square.b0064d84005a3755de49ed87ec262a0a.svg";
export { ForwardRef as ReactComponent };